import * as React from 'react';
import {useState} from 'react';
import InputLabel from '@mui/material/InputLabel';
import  Button  from '@mui/material/Button';
import OrganizationData from '../../../data/OrganizationData';
import SoftBrandingData from '../../../data/SoftBrandingData';
import SoftBrandingInformation from './SoftBrandingInformation';
import { Height } from '@mui/icons-material';

 const  SoftBrandingEdit = ({data, onFieldChange, onSave}) => {    //  const [row, setRow] = useState(LicenceData);
    console.log("Data SoftBranding: ",data);
    
    const [organization, setOrganization] = useState(data);
    const [errorMessage, setErrorMessage] = useState(false);
    const [savedMessage, setSavedMessage] = useState(false);
    const [warningFlag, setWarningFlag] = useState(false);
    const [message, setMessage] = useState("");
    
    console.log("SoftBrandingData: ",organization);

    const handleSavePasswordPolicySetting = (value, id) => {
        console.log("EnableSavePasswordPolicy: ", value, id)
        var sb = SoftBrandingData;
        if (organization.softBrandingBlob !== null && organization.softBrandingBlob !== "") {
            sb = JSON.parse(organization.softBrandingBlob);
        }
        var x = null;
        switch(id) {
            case "companyName":
                sb = {...sb, companyName: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "productName":
                sb = {...sb, productName: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "logoMainScreen":
                sb = {...sb, logoMainScreen: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "logoLoginScreen":
                sb = {...sb, logoLoginScreen: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "logoClinic":
                sb = {...sb, logoClinic: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "logoSplashScreen":
                sb = {...sb, logoSplashScreen: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "logoReport":
                sb = {...sb, logoReport: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "backgroundImage":
                sb = {...sb, backgroundImage: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "backgroundVideo":
                sb = {...sb, backgroundVideo: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "applicationColor1":
                sb = {...sb, applicationColor1: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "applicationColor2":
                sb = {...sb, applicationColor2: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "splashScreenColor":
                sb = {...sb, splashScreenColor: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "website":
                sb = {...sb, website: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "manualLink":
                sb = {...sb, manualLink: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "correctivesLink":
                sb = {...sb, correctivesLink: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "supportWebsite":
                sb = {...sb, supportWebsite: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "supportEmail":
                sb = {...sb, supportEmail: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "customTerms":
                sb = {...sb, customTerms: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
            case "regions":
                sb = {...sb, regions: value};
                x = {...organization, softBrandingBlob: JSON.stringify(sb)};
                setOrganization(x);
                onFieldChange(x);
                break;
          default:
            console.log("None: ",id, value);
            break;
        }
      }

    const handleSave = (event) => {
        event.preventDefault();
        console.log("Save: ",organization);
        try{
            onSave();
            setSavedMessage(true);
            setErrorMessage(false);
            setTimeout(() => {
                setSavedMessage(false);
            }, 5000);
        } catch (error) {
            console.log("Error: ",error);
            setErrorMessage(true);
            setSavedMessage(false);
            setTimeout(() => {
                setErrorMessage(false);
            }, 5000);
        }
    }

    if (organization !== undefined) {
    return (
        <div>
        <form onSubmit={handleSave}>
            <div className="formInput"  style={{margin:"10px", width:"75%"}}>
               
                <box sx={{Height:"600px"}} >
                    <SoftBrandingInformation
                     data = {organization.softBrandingBlob !== null ? JSON.parse(organization.softBrandingBlob) : SoftBrandingData}
                     onFieldChange={(value, id) => handleSavePasswordPolicySetting(value, id)}
                    />
                    
                </box>
                <div className="formButtons" style={{width:"100%"}} >
                    <div className="left">
                        {errorMessage && <div className="error">An error occurred</div>}
                        {savedMessage && <div className="message">Soft Branding Saved</div>}
                        {warningFlag && <div className="warning">{message}</div>}
                    </div>
                    <div className="right">
                        <Button  
                            type="submit"
                            variant="contained"
                            className="button"
                            sx={{marginBottom: 10}}
                            >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </form>
        </div>
    );
    } else {
        return (<label>Loading...</label>)
    }
}

export default SoftBrandingEdit;